module.exports = __webpack_public_path__ + "assets/a268032c522f909f383567ec25b497aa.mp3";